import React from 'react'
import { Icon } from './EnterInfo.elements'

type Props = {
  className?: string
}

export const EnterInfoIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 48 48"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M41 23.5V7.56A1.56 1.56 0 0039.44 6H6.56A1.56 1.56 0 005 7.56v28.88c0 .862.699 1.56 1.56 1.56h20.07M25 17.4h12M25 25.4h4M25 21.4h12" stroke="#1A1C1F" strokeWidth="1.2" />
    <circle cx="15.199" cy="17.92" stroke="#1A1C1F" strokeWidth="1.2" r="2.86" />
    <path d="M20.204 26.5a5.005 5.005 0 10-10.01 0" stroke="#1A1C1F" strokeWidth="1.2" />
    <path d="M37 42.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666z" fill="#128EE8" />
    <path d="M33.528 33.852l2.571 2.571 5.201-5.2" stroke="#fff" strokeWidth="1.2" />
  </Icon>
)
